import { useParams } from "react-router";
import { InspectionMilestones } from "./_components/milestone";

export default function OverviewRoute() {
  const { processId } = useParams();
  return (
    <div className="grid grid-cols-1 gap-4">
      <InspectionMilestones processId={processId!} />
    </div>
  );
}
